import React from 'react';
const headers = {
  consolidated: {
    regular: claim => [{
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.business_unit?.name || '',
      valueFn: r => r.data.object.business_unit?.name || ''
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.project_name || '',
      valueFn: r => r.data.object.claim_project_report?.project_name || ''
    }, {
      text: 'Project Type',
      cellType: 'ProjectTypeDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.program_type || '',
      valueFn: r => r.data.object.claim_project_report?.program_type || ''
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      cellType: 'text',
      disabled: true,
      translateValue: true,
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => r.data.object.rate_type || ''
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, {
      text: 'Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => r.data.object.fragmentable?.name || ''
    }, {
      text: 'Paye Number',
      fieldName: 'paye_ref_number',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.paye_ref_number,
      valueFn: r => r.data.object.fragmentable?.paye_ref_number || ''
    }, {
      text: 'Description of Activity',
      fieldName: 'description_of_activity',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.description_of_activity,
      valueFn: r => r.data.object.fragmentable?.description_of_activity || ''
    }, {
      text: '3rd Party Staff Provider',
      cellType: 'StaffProviderDropdown',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.staff_provider.name,
      valueFn: r => r.data.object.fragmentable?.staff_provider?.name || ''
    }, {
      text: 'Total Cost (£)',
      fieldName: 'total',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => r.data.object.total ?? ''
    }, claim.is_external_workers_rate_reduction_required ? {
      text: 'Reduction Factor',
      fieldName: 'reduction_rate_percentage',
      disabled: true,
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.reduction_rate_percentage),
      valueFn: r => r.data.object.reduction_rate_percentage != null ? `${Number(r.data.object.reduction_rate_percentage).toFixed(1)}%` : ''
    } : null, claim.is_external_workers_rate_reduction_required ? {
      text: 'Eligible Total',
      fieldName: 'eligible_total_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_total_amount),
      valueFn: r => r.data.object.eligible_total_amount ?? ''
    } : null, {
      width: '90px',
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => r.data.object.capitalised_costs ?? ''
    }, {
      width: '90px',
      text: 'EPW Confirmation',
      fieldName: 'externally_provided_worker',
      cellType: 'checkbox',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.externally_provided_worker,
      valueFn: r => r.data.object.fragmentable?.externally_provided_worker ? '✓' : ''
    }, {
      text: 'Connected Party',
      fieldName: 'connected_party',
      cellType: 'checkbox',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.connected_party,
      valueFn: r => r.data.object.fragmentable?.connected_party ? '✓' : ''
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? `${Number(r.data.object.direct_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? `${Number(r.data.object.indirect_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? `${Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1)}%` : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? `${Number(r.data.object.eligible_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Allocation',
      fieldName: 'allocation',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.allocation,
      valueFn: r => r.data.object.fragmentable?.allocation != null ? `${Number(r.data.object.fragmentable.allocation).toFixed(1)}%` : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => r.data.object.rnd_amount ?? ''
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => r.data.object.pnl_expenditure ?? ''
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => r.data.object.s1308_claim ?? ''
    }].filter(Boolean),
    realtime: claim => [{
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.business_unit?.name || '',
      valueFn: r => r.data.object.business_unit?.name || ''
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.project_name || '',
      valueFn: r => r.data.object.claim_project_report?.project_name || ''
    }, {
      text: 'Project Type',
      cellType: 'ProjectTypeDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report?.program_type || '',
      valueFn: r => r.data.object.claim_project_report?.program_type || ''
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      cellType: 'text',
      disabled: true,
      translateValue: true,
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => r.data.object.rate_type || ''
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, {
      text: 'Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => r.data.object.fragmentable?.name || ''
    }, {
      text: 'Paye Number',
      fieldName: 'paye_ref_number',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.paye_ref_number,
      valueFn: r => r.data.object.fragmentable?.paye_ref_number || ''
    }, {
      text: 'Description of Activity',
      fieldName: 'description_of_activity',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.description_of_activity,
      valueFn: r => r.data.object.fragmentable?.description_of_activity || ''
    }, {
      text: '3rd Party Staff Provider',
      cellType: 'StaffProviderDropdown',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.staff_provider.name,
      valueFn: r => r.data.object.fragmentable?.staff_provider?.name || ''
    }, {
      text: 'Total Cost (£)',
      fieldName: 'total',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => r.data.object.total ?? ''
    }, claim.is_external_workers_rate_reduction_required ? {
      text: 'Reduction Factor',
      fieldName: 'reduction_rate_percentage',
      disabled: true,
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.reduction_rate_percentage),
      valueFn: r => r.data.object.reduction_rate_percentage != null ? `${Number(r.data.object.reduction_rate_percentage).toFixed(1)}%` : ''
    } : null, claim.is_external_workers_rate_reduction_required ? {
      text: 'Eligible Total',
      fieldName: 'eligible_total_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_total_amount),
      valueFn: r => r.data.object.eligible_total_amount ?? ''
    } : null, {
      width: '90px',
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => r.data.object.capitalised_costs ?? ''
    }, {
      width: '90px',
      text: 'EPW Confirmation',
      fieldName: 'externally_provided_worker',
      cellType: 'checkbox',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.externally_provided_worker,
      valueFn: r => r.data.object.fragmentable?.externally_provided_worker ? '✓' : ''
    }, {
      text: 'Connected Party',
      fieldName: 'connected_party',
      cellType: 'checkbox',
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.connected_party,
      valueFn: r => r.data.object.fragmentable?.connected_party ? '✓' : ''
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? `${Number(r.data.object.direct_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? `${Number(r.data.object.indirect_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? `${Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1)}%` : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? `${Number(r.data.object.eligible_rnd_percentage).toFixed(1)}%` : ''
    }, {
      text: 'Allocation',
      fieldName: 'allocation',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      model: 'fragmentable',
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.allocation,
      valueFn: r => r.data.object.fragmentable?.allocation != null ? `${Number(r.data.object.fragmentable.allocation).toFixed(1)}%` : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => r.data.object.rnd_amount ?? ''
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => r.data.object.pnl_expenditure ?? ''
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => r.data.object.s1308_claim ?? ''
    }].filter(Boolean)
  }
};
export const staffingCostFragmentTableSettings = {
  headers
};